import { Component, OnInit , Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-dialog-content-example2',
  templateUrl: './dialog-content-example2.component.html',
  styleUrls: ['./dialog-content-example2.component.scss']
})
export class DialogContentExample2Component implements OnInit {
  private App_ID: number;
  private Doctor_Name: string;
  // private cpT_Id: number;
  private Symptoms_Name: string;
  private Diseases_Name: string;
  private Select_Day: string;
  private From_Time: string;
  private To_Time: string;
  private Approved_Status:string
  apptmts : any =[];

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,private service:ServiceService,) { 
    this.App_ID=1
    this.Doctor_Name='API'
    // this.cpT_Id=0
    this.Symptoms_Name='fever'
    this.Diseases_Name='disease'
    this.Select_Day='Monday'
    this.From_Time='10:30 AM'
    this.To_Time='11:30 AM'
    this.Approved_Status='Approved'
  }

  ngOnInit(): void {
    console.log('test')
    console.log(this.data)
    // this.get()
  }

  // get(){
  //   this.service.Get_Appointment_byId()
  //   .subscribe(data=>{
  //     console.log(data)
  //     this.apptmts=data
  //   })
  // }
}
